import { render } from "./ShowFormModal.vue?vue&type=template&id=2611bdc1"
import script from "./ShowFormModal.vue?vue&type=script&lang=js"
export * from "./ShowFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__